const state = {
    name: "用户名",
};

const mutations = {
    setName(state, data) {
        state.name = data;
    },
};

const actions = {
    // 异步操作
    async updateUserName({ commit }, data) {
        commit('setName', data);
    },
};

const getters = {};

export default {
    namespaced: true, // 推荐开启命名空间
    state,
    mutations,
    actions,
    getters,
};
